<template>
  <div class="cinema-item clearfix" @click="toCinema">
    <div class="cinema-detail">
      <div class="left">
        <div class="cinema-name">{{info.name}}</div>
        <div class="address">{{info.address}}</div>
      </div>
      <div class="right">
        <span :class="{'hidePrice' : info.lowPrice <= 0}">
          <decimal-price :price="info.lowPrice" myclz="cinema-lowPrice"></decimal-price>
          <span class="qi">起</span>
        </span>
        <div class="distance">{{getDistance(info.gpsAddress)}}</div>
      </div>
    </div>
    <div class="cinema-schedule-wrap clearfix" v-if="info.isVisited == 1">
      <div v-for="s in schedules" :class="isStopChooseSeat(s) ? 'disable schedule-item' : 'schedule-item' " :key="s.scheduleId" @click.stop="toSeatchart(s)">
        <div class="state-at">{{s.showAt | date_show_time}}</div>
        <div class="language">{{s.filmLanguage + s.imagery}}</div>
        <div class="price">
          <span class="price-icon">￥</span>
          <span>{{ s.minSalePrice | schedule_price }}</span>
          <span class="upon" v-if="isSectionPrice(s)">起</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex'

import DecimalPrice from '../../../components/decimal-price'
import { isStopSelling, getDistanceBetween } from '../../../util/function'

export default {
  name: 'cinema-item',
  props: {
    info: {
      type: Object,
      required: true,
    },
    className: String,
    cinemaId: String,
    filmId: String,
    date: String,
  },
  methods: {
    ...mapActions(['getScheduleList']),
    toCinema() {
      this.$emit('handleCinemaClick')
    },
    toSeatchart(s) {
      this.$emit('handleScheduleClick', s)
    },
    isStopChooseSeat(schedule) {
      return isStopSelling(schedule.showAt, schedule.advanceStopMins)
    },
    getDistance(gps) {
      return getDistanceBetween(gps, this.currentPosition) != '距离未知' ? `${getDistanceBetween(gps, this.currentPosition)}km` : '距离未知'
    },
    isSectionPrice(schedule) {
      return schedule.minSalePrice !== schedule.maxSalePrice
    },
  },
  components: {
    decimalPrice: DecimalPrice,
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      currentPosition: state => `${state.city.gps.latitude}:${state.city.gps.longitude}`,
    }),
    ...mapGetters(['getScheduleListByKey']),
    schedules() {
      const k = String(this.filmId) + String(this.cinemaId) + String(this.date)
      const l = this.getScheduleListByKey(k)
      return l
    },
  },
  mounted() {
    if (this.info.isVisited != 1) {
      return
    }
    this.getScheduleList({
      filmId: this.filmId,
      cinemaId: this.cinemaId,
      date: this.date,
    })
  },
}
</script>
<style lang="less" scoped>
@import '../../../../stylesheet/variable.less';
@disableWhite: rgb(210, 214, 220);

.cinema-item {
  padding: 15px;
  position: relative;
  // border-top: solid #ededed 0.5px;
  &:not(:first-child):after {
    .setTopLine();
  }
  .cinema-detail {
    height: 45px;
    // margin: 15px 0;
    display: flex;
    .left {
      width: calc(~'100vw - 100px');
      .cinema-name {
        font-size: 15px;
        margin-bottom: 5px;
        color: #191a1b;
        .dotOverflow();
      }
      .address {
        font-size: 13px;
        color: @steelGrey;
        .dotOverflow();
      }
    }
    .right {
      color: @orange;
      width: 70px;
      text-align: right;
      .qi {
        font-size: 10px;
      }
      .distance {
        color: @steelGrey;
        font-size: 10px;
        line-height: 26px;
      }
      .hidePrice {
        visibility: hidden;
      }
    }
  }
  .cinema-schedule-wrap {
    // height: 75px;
    width: 100%;
    display: flex;
    display: -webkit-flex;
    overflow-x: scroll;
    padding-top: 15px;
    &::-webkit-scrollbar {
      display: none;
    }
    .disable {
      .state-at {
        color: @disableWhite !important;
      }
      .language {
        color: @disableWhite !important;
      }
      .price {
        color: @disableWhite !important;
      }
    }
    .schedule-item {
      height: 60px;
      width: 70px;
      float: left;
      flex-shrink: 0;
      -webkit-flex-shrink: 0;
      text-align: center;
      margin-right: 10px;
      padding: 6px 0;
      background-color: rgba(244, 244, 244, 0.6);
      .state-at {
        font-size: 14px;
        color: #191a1b;
        line-height: 17px;
      }
      .language {
        font-size: 10px;
        color: @lightSliver;
        width: 60px;
        line-height: 14px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        margin: 0 auto;
        margin-top: 1px;
      }
      .price {
        font-size: 13px;
        color: @butterscotch;
        .price-icon,
        .upon {
          font-size: 8px;
        }
      }
    }
  }
}
</style>
